import {
  PaymentMethod as ApiPaymentMethod,
  PaymentMethodsResponse,
  PaymentMethodBrand as ApiPaymentMethodBrand,
} from 'lib/generated/api'
import {
  PaymentMethod,
  PaymentMethodBrand,
  PaymentMethodRow,
  PaymentMethods,
} from 'types/entities'

const paymentMethodBrandMap: Record<
  ApiPaymentMethodBrand,
  PaymentMethodBrand
> = {
  AMEX: 'Amex',
  DINERS: 'Diners',
  DISCOVER: 'Discover',
  JCB: 'JCB',
  MASTERCARD: 'Mastercard',
  UNIONPAY: 'Union Pay',
  VISA: 'Visa',
  UNKNOWN: 'Unknown',
}

export type PaymentMethodMapper = (data: ApiPaymentMethod) => PaymentMethod

export const mapToPaymentMethod: PaymentMethodMapper = data => {
  const { id, isDefault, paymentMethodDisplayDetails } = data
  const paymentMethod: PaymentMethod = {
    id,
    isDefault,
    paymentMethodDisplayDetails: {
      brand: paymentMethodDisplayDetails?.brand
        ? paymentMethodBrandMap[paymentMethodDisplayDetails?.brand]
        : undefined,
      last4: paymentMethodDisplayDetails?.last4,
      expirationMonth: paymentMethodDisplayDetails?.expirationMonth,
      expirationYear: paymentMethodDisplayDetails?.expirationYear,
    },
  }
  return paymentMethod
}

export type PaymentMethodsResponseMapper = (
  data: PaymentMethodsResponse
) => PaymentMethods
export const mapToPaymentMethods: PaymentMethodsResponseMapper = response => {
  const results: PaymentMethod[] = response.results.map(mapToPaymentMethod)
  return {
    results,
  }
}

export type BillingMapper = (
  response: PaymentMethodsResponse
) => PaymentMethodRow[]
export const mapToBilling: BillingMapper = response =>
  response.results.map(data => {
    const paymentMethod = mapToPaymentMethod(data)
    return {
      id: paymentMethod.id,
      isSelected: paymentMethod.isDefault,
      brand: paymentMethod.paymentMethodDisplayDetails?.brand,
      last4: paymentMethod.paymentMethodDisplayDetails?.last4,
      expirationMonth:
        paymentMethod.paymentMethodDisplayDetails?.expirationMonth,
      expirationYear: paymentMethod.paymentMethodDisplayDetails?.expirationYear,
    }
  })
